/* eslint-disable react/prop-types */
// Speedometer.jsx
import React from 'react'

const SpeedometerDefault = function SpeedometerDefault ({ style }) {
  return (
    <SpeedometerOn style={style} />
  )
}

export default SpeedometerDefault

export const SpeedometerOn = function SpeedometerOn ({ color, style }) {
  const defaultStyle = {
    fill: color || '#284047',
    shapeRendering: 'geometricPrecision',
    imageRendering: 'optimizeQuality',
    stroke: color || '#284047',
    strokeWidth: 6.7,
    textRendering: 'geometricPrecision',
  }
  const svgStyle = { ...defaultStyle, ...style }
  return (
    <svg
      style={svgStyle}
      viewBox='0 0 75 75'
    >
      <description>speedometer icon</description>
      <title>speed</title>
      <g
        style={{
          transform: 'translate(4px, 9px) scale(0.3)',
        }}
      >
        <path
          strokeWidth='3'
          d='M110 90c-11,0 -19,9 -19,20 0,10 8,19 19,19 11,0 20,-9 20,-19 0,-11 -9,-20
          -20,-20zm0 5c-8,0 -14,7 -14,15 0,7 6,14 14,14 8,0 15,-7 15,-14 0,-8 -7,-15 -15,-15z'
        />
        <path d='M221 109c1,25 -7,50 -23,70l-8 -13c12,-18 17,-38 17,-57l14 0z' />
        <path d='M188 34c18,18 29,40 33,65l-15 0c-3,-21 -13,-40 -28,-54l10 -11z' />
        <path d='M117 4c23,1 46,9 64,24l-10 10c-16,-12 -35,-19 -54,-20l0 -14z' />
        <path d='M43 28c19,-15 42,-23 65,-24l0 14c-19,1 -38,8 -54,20l-11 -10z' />
        <path d='M4 99c3,-24 14,-47 32,-65l11 11c-16,15 -25,34 -28,54l-15 0z' />
        <path d='M26 179c-16,-20 -23,-46 -23,-70l15 0c-1,19 5,39 16,56l-8 14z' />
        <circle fill='none' cx='114' cy='110' r='14' />
        <path stroke='none' d='M158 49l-49 51c-9,2 -11,12 -5,17 7,6 17,0 16,-8l38 -60z' />
      </g>

    </svg>
  )
}

export const SpeedometerOff = function SpeedometerOff ({ color, style }) {
  const defaultStyle = {
    fill: color || '#284047',
    shapeRendering: 'geometricPrecision',
    imageRendering: 'optimizeQuality',
    stroke: color || '#284047',
    strokeWidth: 6.7,
    textRendering: 'geometricPrecision',
  }
  const svgStyle = { ...defaultStyle, ...style }
  return (
    <svg
      style={svgStyle}
      viewBox='0 0 75 75'
    >
      <g
        style={{
          transform: 'translate(4px, 9px) scale(0.3)',
        }}
      >
        <path
          strokeWidth='3'
          d='M114 90c11,0 20,9 20,20 0,10 -9,19 -20,19 -11,0 -19,-9 -19,-19 0,-11 8,-20 19,-20zm0
            5c8,0 15,7 15,15 0,7 -7,14 -15,14 -7,0 -14,-7 -14,-14 0,-8 7,-15 14,-15z'
        />
        <path d='M3 109c0,25 7,50 23,70l8 -13c-11,-18 -17,-38 -16,-57l-15 0z' />
        <path d='M36 34c-18,18 -29,40 -32,65l15 0c3,-21 13,-40 28,-54l-11 -11z' />
        <path d='M108 4c-23,1 -46,9 -65,24l11 10c16,-12 34,-19 54,-20l0 -14z' />
        <path d='M181 28c-18,-15 -41,-23 -64,-24l0 14c19,1 38,8 54,20l10 -10z' />
        <path d='M221 99c-3,-24 -14,-47 -32,-65l-11 11c16,15 25,34 28,54l15 0z' />
        <path d='M198 179c17,-20 24,-46 23,-70l-14 0c0,19 -5,39 -17,56l8 14z' />
        <circle fill='none' cx='110' cy='110' r='14' />
        <path stroke='none' d='M50 153l55 -46c2,-8 13,-10 18,-3 4,7 -2,16 -10,15l-63 34z' />
      </g>
    </svg>
  )
}
